import Body from 'commons/card/Body';
import CollapsableCard from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import GenericGrid from 'pages/tables/GenericGrid';
import React, { Fragment } from 'react';

export default function Vnl(props) {
  const vnlDistr =
    props.data.data?.vnlDistr === undefined ? [] : props.data.data?.vnlDistr;
  const vnl = props.data.data?.vnl === undefined ? [] : props.data.data?.vnl;
  const reserv =
    props.data.data?.reserv === undefined ? [] : props.data.data?.reserv;

  return (
    <Fragment>
      <GenericGrid
        canExport={true}
        autoSize={true}
        showCreateBtn={false}
        definition={props.data.meta.definition.filter(
          (x) => x.typeReq === 'vnl'
        )}
        data={vnl}
        hideToolbar={true}
      />

      {vnl !== undefined && (
        <CollapsableCard expanded={false}>
          <Header title='Distribution des VNL'></Header>
          <Body>
            <GenericGrid
              canExport={true}
              autoSize={true}
              showCreateBtn={false}
              definition={props.data.meta.definition.filter(
                (x) => x.typeReq === 'vnlDistr'
              )}
              data={vnlDistr}
            />
          </Body>
        </CollapsableCard>
      )}
      {reserv !== undefined && (
        <CollapsableCard expanded={false}>
          <Header title='Détail des réservations'></Header>
          <Body>
            <GenericGrid
              canExport={true}
              autoSize={true}
              showCreateBtn={false}
              definition={props.data.meta.definition.filter(
                (x) => x.typeReq === 'reserv'
              )}
              data={reserv}
            />
          </Body>
        </CollapsableCard>
      )}
    </Fragment>
  );
}
